import { ComponentType } from '@angular/cdk/overlay';
import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MessageType } from '../../src';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { DynamicMatDialog } from '../dynamic-dialog/dynamic-dialog';
import { Transition, TransitionService } from '@uirouter/angular';

@Injectable({
    providedIn: 'root'
})
export class DialogService {
    public static $name: string = 'clDialogService';

    private renderer: Renderer2;

    constructor(
        public dialog: MatDialog,
        @Inject(DOCUMENT) private document: Document,
        private dynamicDialog: DynamicMatDialog,
        private rendererFactory: RendererFactory2,
        private transitionService: TransitionService
    ) {
        this.renderer = this.rendererFactory.createRenderer(null, null);
    }

    showMessageDialog(title: string, message: string, messageType: MessageType) {
        const options: MatDialogConfig = {
            data: {
                confirmBtnText: 'Ok',
                message,
                messageType,
                showCancelBtn: false,
                title
            }
        };

        return this.dialog.open(ConfirmDialogComponent, options);
    }

    showMessageListDialog(title: string, message: string, messageType: MessageType, messages: any[], formatter: (item: any) => string) {
        const options: MatDialogConfig = {
            data: {
                confirmBtnText: 'Ok',
                message,
                messageType,
                messages,
                formatter,
                showCancelBtn: false,
                title
            }
        };

        return this.dialog.open(ConfirmDialogComponent, options);
    }

    showConfirmDialog(options: MatDialogConfig) {
        return this.dialog.open(ConfirmDialogComponent, options);
    }

    showDialog(component: ComponentType<any>, options: MatDialogConfig) {
        return this.dialog.open(component, options);
    }

    /**
     * Dialog with #rightViewArea as root instead of body
     */
    showDialogView(component: ComponentType<any>, options?: MatDialogConfig) {
        this.setDialogViewContainer();
        const dialogRef = this.dynamicDialog.open(component,
            {
                ...options,
                width: '100%',
                height: '100%',
                maxWidth: '100%'
            });

        const deregisterTransitionOnRouteChange = this.transitionService.onStart({}, (trans: Transition) => {
            dialogRef?.close();
        });

        dialogRef
            .afterClosed()
            .subscribe(() => {
                deregisterTransitionOnRouteChange();
            });

        return dialogRef;
    }

    private setDialogViewContainer() {
        const dialogContainerId = 'rightViewArea';
        const dialogOverlayContainerElement = this.document.getElementById(dialogContainerId);
        this.dynamicDialog.setContainerElement(dialogOverlayContainerElement, this.renderer);
    }
}
